const isProduction = process.env.NODE_ENV === 'production';

export const API_BASE_URL = isProduction 
  ? 'https://materia-backend.onrender.com' 
  : 'http://localhost:5000';

// Replace 'your-netlify-site-url' with your actual Netlify site URL
